import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    // Tarayıcının hafızasından token'ı kontrol et
    const token = localStorage.getItem('userToken');

    if (!token) {
        // Eğer token yoksa, kullanıcıyı ana sayfaya (Login sayfasına) yönlendir
        return <Navigate to="/" />;
    }

    // Eğer token varsa, kullanıcının sayfayı görmesine izin ver
    return children;
};

export default ProtectedRoute;